import { render, staticRenderFns } from "./ScannedAttachments.vue?vue&type=template&id=9b1099b0"
import script from "./ScannedAttachments.vue?vue&type=script&lang=js"
export * from "./ScannedAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports